(function() {
  'use strict';
  angular.module('fetch-web-angular',['ng']);
})();
'use strict';
(function (angular) {
  angular.module('fetch-web-angular')
  .directive('ftCheckSwitch', [function () {

    return {
      restrict: 'AE',
      scope: {
        modelVariable : '='
      },
      controller: ['$scope', function ($scope) {
        $scope.toggle = function() {
          $scope.modelVariable = !$scope.modelVariable;
        }   
      }],  
      template: '<div class="fetch-check-switch-container" ng-class="{\'checked\': modelVariable }" ng-click="toggle()">'+
                '<label for="fetchCheckBox"></label>'+
                '</div>'
    };
  }]);
})(angular);

'use strict';
/*
 * Module: fetch-web-angular
 * Directive: super footer
 */
(function (angular) {
  angular.module('fetch-web-angular')
  .directive('ftFooterSf', function () {
    return {
      restrict: 'A', // A: Attribute, E: Element, C: Comment.
       controller: ['$scope', function ($scope) {
      	$scope.slideIndex = "";

		$scope.setSlide = function (number) {
    		if ($scope.slideIndex === number) {
    			$scope.slideIndex = undefined;
    		}
    		else {
    			$scope.slideIndex = number;
    		}
	    }
	  }],
      template: '<div class="row clearfix">'+
				'	<div class="super-footer-row">'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(1)" ng-class="{ \'collapsed\': (slideIndex !== 1) }" class="footer-sub-title"><a href="/features">Features</a><span ng-class="{ \'rot180\': (slideIndex == 1)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 1)">'+
				'				<li><a href="/features/timeshifting">Time Shifting</a></li>'+
				'				<li><a href="/features/movies">Movies</a></li>'+
				'				<li><a href="/features-and-packages/streaming-apps-landing">Apps</a></li>'+
				'				<li><a href="/features/mobile">Mobile</a></li>'+
        '       <li><a href="/features/simplesetup">Simple setup</a></li>'+
				'				<li><a href="/products/compare">Compare boxes</a></li>'+
				'			</ul>'+
				'		</div>'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(2)" ng-class="{ \'collapsed\': (slideIndex !== 2) }" class="footer-sub-title"><a href="/tv">TV</a><span ng-class="{ \'rot180\': (slideIndex == 2)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 2)">'+
				'				<li><a href="/tv/guide">TV Guide</a></li>'+
				'				<li><a href="/tv/store">TV Store</a></li>'+
				'				<li><a href="/tv/catchuptv">TV Apps</a></li>'+
				'			</ul>'+
				'		</div>'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(3)" ng-class="{ \'collapsed\': (slideIndex !== 3) }" class="footer-sub-title"><a href="/movies">Movies</a><span ng-class="{ \'rot180\': (slideIndex == 3)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 3)">'+
				'				<li><a href="/movie/store">Movies Store</a></li>'+
				'				<li><a href="/movie/box">Movie Box</a></li>'+
				'			</ul>'+
				'		</div>'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(4)" ng-class="{ \'collapsed\': (slideIndex !== 4) }" class="footer-sub-title"><a href="/packages">Packages</a><span ng-class="{ \'rot180\': (slideIndex == 4)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 4)">'+
				'				<li><a href="/packages/premium-channels">Premium Channels</a></li>'+
				'				<li><a href="/support/multiroom">Multiroom</a></li>'+
				'			</ul>'+
				'		</div>'+
				'	</div>'+
				' <div class="super-footer-row">'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(5)" ng-class="{ \'collapsed\': (slideIndex !== 5) }" class="footer-sub-title"><a href="/packages/special-interest">Special Interest</a><span ng-class="{ \'rot180\': (slideIndex == 5)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 5)">'+
        '       <li><a href="/packages/special-interest/optus-sport">Optus Sport</a></li>'+
        '       <li><a href="/packages/special-interest/bein-sports">beIN SPORTS</a></li>'+
        '       <li><a href="/packages/special-interest/espn">ESPN</a></li>'+
        '       <li><a href="/packages/special-interest/italian">Italian Pack</a></li>'+
        '       <li><a href="/packages/special-interest/tbn-good">TBN Inspire and GOOD</a></li>'+
				'			</ul>'+
				'		</div>'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(7)" ng-class="{ \'collapsed\': (slideIndex !== 7) }" class="footer-sub-title">Corporate<span ng-class="{ \'rot180\': (slideIndex == 7)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 7)">'+
        '       <li><a href="/about-us">About Us</a></li>'+
        '       <li><a href="/contact-us">Contact Us</a></li>'+
        '       <li><a href="/terms-and-conditions">Terms and Conditions</a></li>'+
        '       <li><a href="/privacy-policy">Privacy Policy</a></li>'+
        '       <li><a href="/jobs">Jobs</a></li>'+
        '       <li><a href="/press-releases">Media Releases</a></li>'+
        '       <li><a href="/reviews">Reviews</a></li>'+
				'			</ul>'+
				'		</div>'+
				'		<div class="footer-link-wrap">'+
				'			<span ng-click="setSlide(8)" ng-class="{ \'collapsed\': (slideIndex !== 8) }" class="footer-sub-title">Support<span ng-class="{ \'rot180\': (slideIndex == 8)}" class="glyphicon svg-arrow-filter"></span></span>'+
				'			<ul ng-show="(slideIndex === 8)">'+
				'				<li><a href="/support/user-guides">User Guides</a></li>'+
        '       <li><a href="/faqs">FAQs</a></li>'+
        '       <li><a href="/support/remote">Universal Remote</a></li>'+
        '       <li><a href="/support/fetchtv-closed-captioning">Closed Captions</a></li>'+
        '       <li><a href="/support/mobile-playback">Multi-device Playback Rules</a></li>'+
        '       <li><a href="/support/competition-and-promotions">T&Cs Competitions and promotions</a></li>'+
				'			</ul>'+
				'		</div>'+
				'	</div>'+
				'</div>'
    };
  });
})(angular);

'use strict';
/*
 * Module: fetch-web-angular
 * Directive: heroSection
 *
 * Description: Hero banner that attempts to configure itsef from
 * a JSON spec file located at `<heroSpecRoot>/<$scope.heroName>/spec.json`
 * if no spec file found it will default to hardcoded EV image Hero-EV.png.
 *
 * Expected format for `spec.json`
 * Array of objects with following keys:
 *
 * - heroImageUrl: url for hero background image.
 * - heroText: the text for the top line
 * - heroSubText: text to display under the `heroText`
 * - providerImageUrl: url for the provider image
 * - clickthroughUrl: url to navigate to if user clicks on hero
 */
(function (angular) {
  angular.module('fetch-web-angular')
  .directive('heroSection',[function () {
    return {
      restrict: 'A',
      scope: {
        sectionName: '=',
        heroName: '='
      },
      controller: ['$scope', '$http', '$window', function ($scope, $http, $window) {
        $scope.clickThrough = function () {
          if (angular.isUndefined($scope.heroData.clickthroughUrl)) return;
          $window.location = $scope.heroData.clickthroughUrl;
        }

        $scope.heroData = {};
        var heroSpecRoot = 'marketing/hero';
        function init () {
          var specUrl = sprintf('%s/%s/spec.json', heroSpecRoot, $scope.heroName);
          $http.get(specUrl)
          .then(function (result) {
            $scope.heroData = result.data[_.random(0,result.data.length-1)];
          },
            function () {
              console.log('Error getting hero spec for:', $scope.heroName, '@', specUrl, 'setting default ev');
              //Set default EV path
              var evUrl = sprintf('%s/%s/Hero-EV.png', heroSpecRoot, $scope.heroName);
              $scope.heroData.heroImageUrl = evUrl;
            }
          );
        }
        init();
      }],
      template: '<div class="hero-section no-fade" ng-class="{\'click-through\': heroData.clickthroughUrl }" ng-style="{ \'background-image\': \'url(\\\'\'+heroData.heroImageUrl+\'\\\')\'}" ng-click="clickThrough()">'+
                '  <div class="container container-with-margin">'+
                '    <div class="hero-content">'+
                '      <h2>{{ sectionName }}</h2>'+
                '      <div class="provider-badge-wrap">'+
                '        <img class="provider-badge" ng-src="{{::heroData.providerImageUrl}}" ng-if="::heroData.providerImageUrl"></img>'+
                '        <div class="hero-details" ng-class="{\'has-provider-badge\': heroData.providerImageUrl}">'+
                '          <strong>{{ heroData.heroText }}</strong>'+
                '          <small ng-show="{{ heroData.heroSubText }}">{{ heroData.heroSubText }}</small>'+
                '        </div>'+
                '      </div>'+
                '    </div>'+
                '  </div>'+
                '</div>'
    };
  }]);
})(angular);

(function (angular) {
  'use strict';
  angular.module('fetch-web-angular')
  .directive('hotOnFetch', ['$http', function ($http) {
    return {
      restrict: 'A',
      template: '<ul></ul>',
      link: function (scope, element, attributes) {
        $http.get('/2015-homepage.htm')
          .then(function (result) {
            var hotItems = angular.element('.page-width-tile-c--rotate img', result.data)
              .slice(0,10);
            angular.element(element).children().append(hotItems);
            hotItems.wrap('<li></li>');
          },
            function (e) {
              console.log('error getting hot on fetch items', e)
              //Cannot download hot titles on fetch
            });
      }
    };
  }]);
})(angular);

(function() {
  'use strict';

  angular.module('fetch-web-angular')
    .directive('fetchMainTopNav', ['$window', function($window) {
      return {
        restrict: 'E',
        replace: false,
        controller: function($scope, $element, $attrs, $transclude) {
          $scope.mobilePlatform = '';
          if (/iPhone|iPad/.test($window.navigator.userAgent)) {
            $scope.mobilePlatform = 'iOS';
          }
          if (/Android/.test($window.navigator.userAgent)) {
            $scope.mobilePlatform = 'Android';
          }
          $scope.showHeader = function () { return !$scope.userIsLoggedIn; };
        },
        scope: {
          userIsLoggedIn: '=',
          onAccountClick: '&',
          onShowFullClick:'&'
        },
        template:  '<header ng-if="!userIsLoggedIn">'+
          ' <nav class="navbar navbar-default navbar-fixed-top">'+
          '   <div class="container">'+
          '     <div class="row">'+
          '       <div class="col-lg-12">'+
          '         <div class="navbar-header">'+
          '           <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#fetch-main-nav-bar">'+
          '           <span class="sr-only">Toggle navigation</span>'+
          '           <span class="icon-bar"></span>'+
          '           <span class="icon-bar"></span>'+
          '           <span class="icon-bar"></span>'+
          '           </button>'+
          '           <a class="navbar-brand" href="//www.fetchtv.com.au/">'+
          '             <img src="//www.fetchtv.com.au/img/fetchtv-logo.png">'+
          '           </a>'+
          '         </div>'+
          '         <div class="collapse navbar-collapse branded-nav-bar-menu" id="fetch-main-nav-bar">'+
          '           <ul class="nav navbar-nav navbar-right">'+
          '             <li class="visible-xs"><a href="//www.fetchtv.com.au/"><span>Home</span></a></li>'+
          '             <li><a href="//www.fetchtv.com.au/record-tv-shows-and-series"><span>Features</span></a></li>'+
          '             <li class="hidden-xs"><a href="//www.fetchtv.com.au/tv#!/tv/tvguide"><span>TV</span></a></li>'+
          '             <li class="hidden-xs"><a href="//www.fetchtv.com.au/movies-on-demand#!/movies/rentals"><span>Movies</span></a></li>'+
          '             <li><a href="//www.fetchtv.com.au/packages"><span>Packages</span></a></li>'+
          '             <li class="visible-xs"><a href="//www.fetchtv.com.au/faqs"><span>FAQs &amp; Help</span></a></li>'+
          '             <li><a class="selected" href ng-click="onAccountClick()()"><span>Account</span></a></li>'+
          '             <li class="full-website-section twelve_columns two_up tiles">'+
          '               <p class="no-leading text-center"><small class="white-it">Can\'t find what you\'re looking for?</small></p>'+
          '               <span id="fws-buttons"><a href ng-click="onShowFullClick()()" id="full-website-top" class="tile styled-link large-button grey centerfy">Full Website</a>'+
          '               <a ng-show="mobilePlatform===\'iOS\'" href="https://itunes.apple.com/au/app/fetch-tv/id462093663?mt=8" class="tile ios-app styled-link large-button grey centerfy">Free App</a>'+
          '               <a ng-show="mobilePlatform===\'Android\'" href="intent://scan/#Intent;package=au.com.fetchtv;S.browser_fallback_url=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dau.com.fetchtv;end" class="tile android-app styled-link grey large-button centerfy">Free App</a></span>'+
          '             </li>'+
          '           </ul>'+
          '         </div>'+
          '        </div>'+
          '      </div>'+
          '    </div>'+
          ' </nav>'+
          '</header>'
      };
    }]);
})();

/**
* @ngdoc directive
* @module fetch-web-angular
* @name masterNavbar
* @restrict A
*
* @description
* Configurable master navigator element for fetch websites.
*
* This directive will monitor route changes and update submenu items from the current route's 'submenuOptions' property if available. This can either be an array of menu definitions or a function that returns an array of menu definitions. Expected menu item definitions should use the following properties:
* {
*   name: STRING - Label to for display.
*   hideOnMobile: BOOLEAN, OPTIONAL - When true, this will prevent the submenu item from being added to the mobile menu.
* }
*
* @param menuItems - functions that returns the current top level menu submenuOptions. Expects an array of objects in the following form:
* {
*   name: STRING - Label for menu item
*   iconClass: STRING, OPTIONAL - CSS class name to apply to this menu item
*   noCollapse: BOOLEAN, OPTIONAL - When true, prevents collapsing this menu item into mobile burger menu.
*   badgeCount: FUNCTION, OPTIONAL - Function that returns an INTEGER. If integer is not 0 the value will be displayed to the right of the menu label.
*   hideOnDesktop: BOOLEAN, OPTIONAL - When true, this will prevent the menu item from appearing in the main navigation bar.
* }
* Additional members can be added to menu definition objects but will be ignored.
*
* @param menuClicked - callback function to invoke when user clicks on a menu item, clicked item definition is passed into this method.
*/
'use strict';
(function (angular) {
  angular.module('fetch-web-angular')
  .directive('masterNavbar', [function () {
    return {
      restrict: 'A',
      template: '\
      <header>\
        <nav class="navbar navbar-default navbar-fixed-top">\
          <div class="container">\
            <div class="row">\
              <div class="col-lg-12">\
                <div class="navbar-header">\
                  <a class="navbar-brand" href ng-click="navigateTo({name:\'home\', action:\'home\'})">\
                    <div class="branding-logo"></div>\
                  </a>\
                  <button ng-show="menuItems().length > 0" type="button" class="navbar-toggle collapsed" data-toggle="collapse" ng-click="menuOpen=!menuOpen">\
                    <span class="sr-only">Toggle navigation</span>\
                    <span class="icon-bar"></span>\
                    <span class="icon-bar"></span>\
                    <span class="icon-bar"></span>\
                  </button>\
                  <ul class="mobile-only navbar-no-collapse">\
                    <li ng-repeat="menuItem in menuItems() | filter:{noCollapse:true}">\
                      <a href title="{{::menuItem.name}}" ng-class="{\'selected\': (rootSectionMatch.test(menuItem.name)) }" ng-click="navigateTo(menuItem);">\
                        <span ng-if="::!menuItem.iconClass">\
                          {{::menuItem.name}}\
                        </span>\
                        <div ng-if="::menuItem.iconClass" class="menu-icon">\
                          <div class="svg {{menuItem.iconClass}}"></div>\
                        </div>\
                      </a>\
                    </li>\
                  </ul>\
                </div>\
                <div class="collapse navbar-collapse branded-nav-bar-menu" ng-class="{in:menuOpen}">\
                  <ul class="nav navbar-nav navbar-right">\
                    <li ng-repeat="menuItem in menuItems()" ng-class="{\'desktop-only\':menuItem.noCollapse, \'mobile-only\': menuItem.hideOnDesktop }">\
                      <a href title="{{::menuItem.name}}" ng-class="{\'selected\': (rootSectionMatch.test(menuItem.name)) }" ng-click="navigateTo(menuItem);">\
                        <span ng-if="::!menuItem.iconClass">\
                          {{::menuItem.name}}\
                          <strong ng-show="(menuItem.badgeCount && menuItem.badgeCount())" class="badge">{{ menuItem.badgeCount() }}</strong>\
                        </span>\
                        <div ng-if="::menuItem.iconClass" class="menu-icon">\
                          <div class="svg {{menuItem.iconClass}}"></div>\
                        </div>\
                      </a>\
                      <a\
                        ng-if="(rootSectionMatch.test(menuItem.name))"\
                        ng-repeat="sub in submenuOptions()|filter:mobileSubItemFilter"\
                        href\
                        class="mobile-only"\
                        ng-click="navigateTo(sub);">\
                        <div class="subsection-wrapper" ng-class="{\'selected\': (sectionName===sub.name)}">\
                          <span class="submenu">{{::sub.name}}<span ng-if="sub.secondaryText" class="secondary-text">{{ sub.secondaryText() }}</span></span>\
                        </div>\
                      </a>\
                    </li>\
                  </ul>\
                </div>\
            </div>\
          </div>\
          </div>\
        </nav>\
      </header>\
      <div ng-show="submenuOptions()" class="subsection-menu">\
        <div class="container">\
          <ul class="nav nav-pills">\
            <li ng-repeat="item in submenuOptions()|filter: desktopItemFilter" role="presentation" ng-class="{\'active\': (item.name === sectionName)}">\
              <a href ng-click="navigateTo(item)">\
                <span>{{::item.name}}<span ng-if="item.secondaryText" class="secondary-text">{{ item.secondaryText() }}</span></span>\
              </a>\
            </li>\
          </ul>\
        </div>\
      </div>',
      scope: {
        menuClicked: '&',
        menuItems: '&'
      },
      controller: ['$scope', '$location', function ($scope, $location) {
        $scope.menuOpen = false;
        var defaultMenu = function () { return undefined; };
        $scope.submenuOptions = defaultMenu;
        $scope.$on("$routeChangeSuccess", function(event, current, previous) {
          if (!current.$$route) return;
          var submenu = current.$$route.submenuOptions;
          if (angular.isUndefined(submenu)) {
            submenu = defaultMenu;
          };
          if (typeof submenu !== 'function') {
            var menuItems = submenu;
            submenu = function () { return menuItems };
          }
          $scope.submenuOptions = submenu;
          $scope.sectionName = current.$$route.routeName;
          $scope.rootSectionMatch = current.$$route.rootSection;
        });

        $scope.desktopItemFilter = function (item) {
          if (item.hideOnDesktop === true) {
            return false;
          }
          return true;
        }

        $scope.mobileSubItemFilter = function (item) {
          if (item.hideOnMobile === true) {
            return false;
          }
          return true;
        }

        $scope.navigateTo = function (section) {
          $scope.menuOpen = false;
          if ($scope.menuClicked ){
            $scope.menuClicked({relData:section});
          }

        }
      }]
    };
  }]);
})(angular);

(function (angular) {
    'use strict';
    angular.module('fetch-web-angular')
        .directive('ftPin', ['$timeout',function ($timeout) {
            return {
                restrict: 'EA',
                scope: {
                  enteredPin: '=',
                  pinCompleted: '&',
                  invalidEntry: '&',
                  autoFocus: '@',
                  blurOnCompleted: '@'
                },
                template:
                '<div class="pin-box-container">' +
                '  <div class="pin-area">' +
                '    <div>' +
                '      <span ng-repeat="digit in [0,1,2,3]" ng-class="{\'selected\': isSelectedDigit(digit)}" ng-click="selectDigit()">' +
                '        <svg ng-if=\'enteredPin[digit]\' height="16" width="16">' +
                '          <g>' +
                '            <circle r="7.8" cy="8" cx="8" style="fill:#000000" />' +
                '          </g>' +
                '        </svg>' +
                '      </span>' +
                '    </div>' +
                '   <input ng-pattern="/^[0-9]{1,4}$/" type="tel" maxlength="4" ng-click="selectDigit()" ng-paste="pasted()" ng-keyup="keyUp()" ng-model="enteredPin" ng-model-options="{ updateOn: \'keyDown input\' }"></input>' +
                '  </div>' +
                '</div>',
                compile: function () {
                    function preLink (scope, iElement, iAttrs, controller) {}
                    function postLink (scope, iElement, iAttrs, controller) {

                        var realInput = angular.element('.pin-area input', iElement),
                          autoFocus = angular.isDefined(scope.autoFocus) ? scope.autoFocus === 'true' : false,
                          blurOnCompleted = angular.isDefined(scope.blurOnCompleted) ? scope.blurOnCompleted === 'true' : false;

                        scope.selectDigit = function () {
                            realInput.focus();
                            var element = realInput[0];
                            var cursorPosition = (element.value || '').length;
                            element.setSelectionRange(cursorPosition,cursorPosition);
                        }

                        scope.isSelectedDigit = function (digit) {
                            if (!realInput.is(':focus')) return false;
                            var element = realInput[0];
                            var slc = element.selectionStart === digit || (element.selectionStart > 3 && digit === 3);
                            return slc;
                        }

                        scope.enteredPin = scope.enteredPin || '';
                        function pinChanged() {
                            var element = realInput[0],
                                cleanVal = (/[0-9]{1,4}/.exec(element.value) || [''])[0]; // Clean out invalid characters.

                            if (element.value !== cleanVal){
                                scope.invalidEntry();
                            }

                            element.value = cleanVal;  //HACK because white space gets ignored and control goes out of sync.
                            scope.enteredPin = cleanVal;
                            scope.selectDigit();
                            if ((scope.enteredPin).length>3 && scope.isSelectedDigit(4)) {
                                if (blurOnCompleted) {
                                  realInput.blur();   //Attempt to dismiss keyboard when submitting.
                                }
                                scope.pinCompleted({relData:scope.enteredPin});
                            }
                        };

                        scope.keyUp = pinChanged;

                        scope.pasted = function () {
                            $timeout(500).then(pinChanged);
                        };

                        if (autoFocus) {
                          $timeout(scope.selectDigit, 500);
                        }
                    }
                    return {
                        pre: preLink,
                        post: postLink
                    };
                }
            };
        }]);
})(angular);

'use strict';
/*
 * Module: fetch-web-angular
 * Directive: scrollClassTrigger
 *
 * Description: Applies a given class name to element when window scroll is above
 *  minimum (and optionally below max) value(s)
 *
 * @param scrollMin - class will be applied to element if windows scroll Y positon exceeds this value (defaults to 0 if not supplied)
 * @param scrollMax - -optional- class will only be applied if scroll Y is below this value.
 * @param scrollPass - -optional- class will be applied once the @scrollMax point has been passed. Requires
 *  a valid @scrollMax expression.
 * @param sampleRate - -optional- sets the frequency at which class is reevaluated in ms. (default: 250ms).
 * @param debug - -optional- enable debugging messages on expression parsing and element scroll.
 *
 * JQuery selectors can also be used to specify a relative element using the following form:
 * $(SELECTOR)@bottom/top[OFFSETEXPRESSION]
 *
 * OFFSETEXPRESSION -
 *
 * One of the following must be present immediately after the selector:
 *  "@top" - get the current top offset for the element
 *  "@bottom" - get the current bottom offset for the element
 *  "@height" - get the current height for the element
 *
 * this expression accepts an optional fixed offset "+/-"
 *
 * Example Usage:
 *
 * <div data-scroll-class-trigger="myClassName" data-scroll-min="$(.someClass)@top+30" data-scroll-max="$(#someThing)@bottom-$(.anotherElement)@height+30"></div>
 *
 */

(function (angular) {
  angular.module('fetch-web-angular')
  .directive('scrollClassTrigger',['$window', '$timeout', function ($window, $timeout) {
    var scrollObserver = Rx.Observable.fromEvent(angular.element($window),'scroll resize'),
      paramParser = /^\$\((.*)\)@(top|bottom)([\-,+]?.*)?/,
      offsetParser = /^([\-.+])\$\(([^\)]*)\)@(top|bottom|height)([\-,+]?.*)?/;
    return {
      restrict: 'A',
      scope: false,
      compile: function () {
        function preLink (scope, iElement, iAttrs, controller) {}
        function postLink (scope, iElement, iAttrs, controller) {
          var element = angular.element(iElement),
              className = iAttrs['scrollClassTrigger'],
              scrollMin = iAttrs['scrollMin'],
              scrollMax = iAttrs['scrollMax'],
              scrollPass = iAttrs['scrollPass'],
              sampleRate = parseInt(iAttrs['sampleRate']) || 250,
              debugEnabled = iAttrs['debug'] === 'true';

          // Parse binding and build function to resolve value
          function getValFn (syntax) {
            if (debugEnabled) console.log('Parse syntax: ', syntax);
            var relPosition = {
              top: function (el) { return el.offset().top; },
              bottom: function (el) { return el.offset().top + relPosition.height(el); },
              height: function (el) { return el.outerHeight() }
            };

            function parseOffset(offsetSyntax) {
              if (debugEnabled) console.log('Parse offsetexpression: ', offsetSyntax);
              if (offsetParser.test(offsetSyntax)) {
                var offsetParts = offsetParser.exec(offsetSyntax),
                  multiplier = (offsetParts[1] === '-' ? -1 : 1),
                  selector = offsetParts[2],
                  relativeFn = relPosition[offsetParts[3]],
                  rawOffset = parseOffset(offsetParts[4]), // Recursive offset resolution YAY!
                  offsetElement = angular.element(selector);

                return function () {
                  return multiplier * ( relativeFn(offsetElement) + rawOffset());
                }
              }
              var offsetVal = parseInt(offsetSyntax) || 0;
              return function () { return offsetVal }
            }

            //jquery matched
            if (paramParser.test(syntax)) {
              if (debugEnabled) console.log('is jQuery expression: ');

              var queryParts = paramParser.exec(syntax),
                selector = queryParts[1],
                relativeFn = relPosition[queryParts[2]],
                offset = parseOffset(queryParts[3]),
                relElement = angular.element(selector);

              if (relElement.length !== 1) {
                console.warn('scrollClassTrigger found unexpected match for relative trigger (should only be one). Expression:', selector, 'count:', relElement.length);
              }

              return function () { return relativeFn(relElement)+offset(); };
            }

            var rawVal = parseInt(syntax) || 0;
              if (debugEnabled) console.log('is raw value:', rawVal);
            return function () { return rawVal; };
          }

          $timeout(function() {
            var min = getValFn(scrollMin),
              max = getValFn(scrollMax);
            var observer = scrollObserver.sample(sampleRate)
              .map(function () {
                return angular.element($window).scrollTop();
              });
            if (debugEnabled)  {
              observer = observer.map(function (val) {
                //Inject debug messages into chain
                console.log('scroll current: '+scrollY+' min: '+min()+' max: '+max());
                return val
              });
            }
            var subscription = observer
              .subscribe(function (scrollY) {
                if (angular.isDefined(scrollPass) && angular.isDefined(scrollMax) && (scrollY >= max())) {
                  element.removeClass(className);
                  element.addClass(scrollPass);
                  return;
                } else {
                  element.removeClass(scrollPass);
                }
                if (scrollY <= min()) return element.removeClass(className); // Min
                element.addClass(className);
              });
            scope.$on('$destroy', function () {
              subscription.dispose();
            });
          }, 1000); // Start after 1s delay in case page auto scrolls
        }
        return {
          pre: preLink,
          post: postLink
        };
      }
    };
  }]);
})(angular);

'use strict';
(function (angular) {
  angular.module('fetch-web-angular')
  .directive('scrollTop',['$window', function ($window) {
    return {
      restrict: 'A',
      compile: function () {
        function preLink (scope, iElement, iAttrs, controller) {}
        function postLink (scope, iElement, iAttrs, controller) {
          angular.element($window).scrollTop(0);
        }
        return {
          pre: preLink,
          post: postLink
        };
      }
    }
  }]);
})(angular);


(function() {
    'use strict';
    angular.module('fetch-web-angular')
        .provider('httpTrafficCopService', function() {

            /*---------------------------------------------------------------------------------*/
            /*  When informed (requestIssued), keeps track of number of calls in a time window */
            /*  And changes status (canIssueRequest), indicating the caller.                   */
            /*  It keeps a counter array, for each tick in time window. and once the           */
            /*  counter array is as big as it can be(60) , it will pop the earliest count and  */
            /*  and pushes in a new tick slot                                                  */
            /*  Time ->     -     -     -      -     -                                         */
            /*           [  5  ,  6  ,  23  ,  0  ,  4  ]                                      */
            /*              ^earliest               ^latest                                    */
            /*  Application is not allowed to send more than REQUEST_THRESHOLD per TIME_WINDOW.*/
            /*---------------------------------------------------------------------------------*/

            var TO_MILLISECONDS_FACTOR = 60 * 1000 ;
            var REQUEST_THRESHOLD = 600 - 1 ; // requests
            var BARE_TIME_WINDOW = 60 ;
            var TIME_WINDOW = BARE_TIME_WINDOW * TO_MILLISECONDS_FACTOR ;  // Milliseconds
            var TICK_WINDOW = TIME_WINDOW / 60 ;   // in every TICK_WINDOW create a new counting slot (in Milliseconds), no more than 60 slots
            var REQUEST_SPEC_PREDICATE = function(config){return true;};
            var enabled = true;
            return{

                enable: function() {

                    enabled = true;
                    return this;

                },

                disable: function() {

                    enabled = false;
                    return this;

                },

                canSendUpTo: function(value){

                    REQUEST_THRESHOLD = value - 1;
                    return this;

                },

                InEveryWindowOf: function(value){

                    BARE_TIME_WINDOW = value;
                    TIME_WINDOW = BARE_TIME_WINDOW * TO_MILLISECONDS_FACTOR;
                    return this;

                },

                minutes:function(){

                    TO_MILLISECONDS_FACTOR = 60*1000;
                    TIME_WINDOW = BARE_TIME_WINDOW * TO_MILLISECONDS_FACTOR;  // Milliseconds

                    return this;
                },
                seconds:function(){

                    TO_MILLISECONDS_FACTOR = 1000;
                    TIME_WINDOW = BARE_TIME_WINDOW * TO_MILLISECONDS_FACTOR;  // Milliseconds
                    return this;

                },

                whenRequestSatisfies: function(fn){

                    REQUEST_SPEC_PREDICATE = fn;
                    return this;
                },

                $get: function() {

                    var observedRequestsInTimeWindow =[0];
                    var lastWarningReportIssuedAt = new Date(1990,1,1);

                    function canIssueRequest(config){

                        if ( !enabled ) return true ;

                        /*console.log( '++++ HTTP TRAFFIC COP SERVICE / CAN ISSUE REQ : ' , config.url, REQUEST_SPEC_PREDICATE(config));*/

                        if (REQUEST_SPEC_PREDICATE(config)){
                            return ( getTotalRequests() <= REQUEST_THRESHOLD ) ;
                        }
                        else{
                            return true;
                        }

                    }

                    function getTotalRequests(){

                        return _.reduce(observedRequestsInTimeWindow,function(memo, num){ return memo + num; },0 )
                    }

                    function requestIssued(config){

                        if (!enabled) return ;

                        if (REQUEST_SPEC_PREDICATE(config)){

                            ++observedRequestsInTimeWindow[observedRequestsInTimeWindow.length-1];
                            /*console.log( '++++ HTTP TRAFFIC COP SERVICE / REQUESTS IN WINDOW : ' + getTotalRequests());*/

                        }

                    }

                    function shouldNotifyRejection(){

                        if (!enabled) return false;

                        var should = (( new Date()).getTime() - lastWarningReportIssuedAt ) > TIME_WINDOW ;

                        /*console.log( '++++ HTTP TRAFFIC COP SERVICE / shouldNotifyRejection: ' ,  should );*/

                        return should ;

                    }

                    function rejectNotificationIssued(){

                        lastWarningReportIssuedAt = ( new Date()).getTime();
                    }

                    function takeSample(){

                        //new sampling slot starts with zero requests.
                        observedRequestsInTimeWindow.push(0);

                        if( TIME_WINDOW / TICK_WINDOW <  observedRequestsInTimeWindow.length ){
                            observedRequestsInTimeWindow.shift();
                        }

                    }

                    function calculateOperationValues(){

                        TIME_WINDOW = BARE_TIME_WINDOW * TO_MILLISECONDS_FACTOR;
                        TICK_WINDOW = TIME_WINDOW / 60;

                    }
                    /*------------------------------*/


                    function init(){
                        if (!enabled) return ;
                        calculateOperationValues();
                        setInterval( takeSample , TICK_WINDOW ) ;
                    }

                    init();

                    return {
                        canIssueRequest: canIssueRequest ,
                        requestIssued: requestIssued ,
                        shouldNotifyRejection: shouldNotifyRejection ,
                        rejectNotificationIssued: rejectNotificationIssued
                    }
                }

            }


        });


})();

(function (angular) {
    'use strict';
angular.module('fetch-web-angular')
    .factory('messageBus', ['$rootScope', '$log',

        function ($rootScope, $log) {

            var messageBus = {};
            messageBus.emitMessage = function (message, args) {
                $log.debug('messageBus.emitMessage - ' + message);
                $rootScope.$emit(message, args);
            };

            messageBus.onMessage = function (message, callback, scope) {
                var unregisterer = $rootScope.$on(message, callback);
                if (scope) {
                    scope.$on('$destroy', unregisterer);
                }
                return unregisterer;
            };

            return {
                emitMessage: messageBus.emitMessage,
                onMessage: messageBus.onMessage
            }
        }
    ]);
})(angular);
(function() {
  'use strict';

  angular.module('fetch-web-angular')
    .factory('tourModalService', function($uibModal, $cookies) {

      function beginTour(){
        $uibModal.open({
          template:
            '<div ng-switch="page" class="slides">'+
            '<div ng-switch-when="1" class="slide">'+
            '<h2>TV & Movie Store</h2>'+
            '<div class="icon-container">'+
            '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 210 120.5"><defs><linearGradient id="linear-gradient" x1="198.91" y1="99.51" x2="152.32" y2="62.9" gradientTransform="matrix(1, 0, 0, -1, -2, 123.15)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2997d3 " stop-opacity="0"/><stop offset="1" stop-color="#048acb "/></linearGradient><linearGradient id="linear-gradient-2" x1="67.31" y1="74.12" x2="87.65" y2="116.12" gradientTransform="matrix(1, 0, 0, -1, 0, 124.3)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#048acb "/><stop offset="1" stop-color="#2997d3 "/></linearGradient></defs><title>test</title><path d="M152,1.65a60.08,60.08,0,0,0-45,20.3,60,60,0,1,0,0,79.4,60,60,0,1,0,45-99.7Z" transform="translate(-2 -1.15)" style="fill:#2997d3 "/><circle cx="150" cy="60.5" r="60" style="fill:url(#linear-gradient)"/><path d="M62,1.15a60,60,0,1,1-60,60A60,60,0,0,1,62,1.15Z" transform="translate(-2 -1.15)" style="fill:url(#linear-gradient-2)"/><path d="M167.3,81.25H136.8a1.54,1.54,0,0,0-1.5,1.5v.4a1.54,1.54,0,0,0,1.5,1.5h30.5a1.54,1.54,0,0,0,1.5-1.5v-.4A1.54,1.54,0,0,0,167.3,81.25Zm13.8-42.6H123a3.37,3.37,0,0,0-3.4,3.4v31.5a3.37,3.37,0,0,0,3.4,3.4h58.1a3.37,3.37,0,0,0,3.4-3.4V42A3.5,3.5,0,0,0,181.1,38.65Zm-1,33.9H124V43h56.1Z" transform="translate(-2 -1.15)" style="fill:#f1f0ef "/><path d="M98.8,77.55H97.4a12.81,12.81,0,0,1-4.5-.4,6,6,0,0,1-2.1-1.3c-.2-.2-.5-.3-.7-.5-2.2-1.5-3.8-1.6-6.3-.6a7.12,7.12,0,0,1-3.5.5,23.13,23.13,0,1,0-18.1,8.7,23.41,23.41,0,0,0,14.6-5.2c.6,0,1.1.1,1.6.1,2.1.1,4.3.3,6.7-.7,1.3-.6,1.6-.5,2.8.2.2.1.4.3.6.4a12.36,12.36,0,0,0,3,1.7,13.36,13.36,0,0,0,4.4.6h2.7a1.79,1.79,0,0,0,1.8-1.8C100.7,78.35,99.9,77.55,98.8,77.55Zm-36.4,2.9a19.3,19.3,0,1,1,19.4-19.3A19.4,19.4,0,0,1,62.4,80.45Zm15.4-20a6.38,6.38,0,0,0-4-3,6.44,6.44,0,0,0-7,9.6,6.38,6.38,0,0,0,4,3,7.77,7.77,0,0,0,1.6.2,6.4,6.4,0,0,0,5.4-9.8Zm-2.8,4a2.74,2.74,0,0,1-1.3,1.7,2.52,2.52,0,0,1-2.1.3,3,3,0,0,1-1.7-1.2,2.86,2.86,0,0,1,.9-3.9,2.3,2.3,0,0,1,1.4-.4,2,2,0,0,1,.7.1,2.74,2.74,0,0,1,1.7,1.3A2.24,2.24,0,0,1,75,64.45Zm-16.9-9.9a6.38,6.38,0,0,0-4-3,6.49,6.49,0,0,0-4.9.8,6.24,6.24,0,0,0-2.9,4,6.87,6.87,0,0,0,.7,4.9,6.38,6.38,0,0,0,4,3,7.72,7.72,0,0,0,1.5.2,6.11,6.11,0,0,0,3.4-1A6.69,6.69,0,0,0,58.1,54.55Zm-4.2,5.8h0a2.52,2.52,0,0,1-2.1.3,2.74,2.74,0,0,1-1.7-1.3,2.58,2.58,0,0,1-.3-2.1,2.74,2.74,0,0,1,1.3-1.7,2.3,2.3,0,0,1,1.4-.4,2,2,0,0,1,.7.1,3,3,0,0,1,1.7,1.2A2.93,2.93,0,0,1,53.9,60.35Zm9.6-3a7.77,7.77,0,0,0,1.6.2,6.31,6.31,0,0,0,6.2-4.9,6.87,6.87,0,0,0-.7-4.9,6.38,6.38,0,0,0-4-3,6.49,6.49,0,0,0-4.9.8,6.3,6.3,0,0,0-2.9,3.9,6.87,6.87,0,0,0,.7,4.9A6.65,6.65,0,0,0,63.5,57.35Zm-1.1-7a3,3,0,0,1,1.2-1.7h0a2.3,2.3,0,0,1,1.4-.4,2,2,0,0,1,.7.1,2.74,2.74,0,0,1,1.7,1.3,2.58,2.58,0,0,1,.3,2.1,2.74,2.74,0,0,1-1.3,1.7,2.58,2.58,0,0,1-2.1.3,2.74,2.74,0,0,1-1.7-1.3A3,3,0,0,1,62.4,50.35Zm-1.1,14.3a6.49,6.49,0,0,0-4.9.8,6.3,6.3,0,0,0-2.9,3.9,6.87,6.87,0,0,0,.7,4.9,6.38,6.38,0,0,0,4,3,7.77,7.77,0,0,0,1.6.2,6.31,6.31,0,0,0,6.2-4.9,6.87,6.87,0,0,0-.7-4.9A6.38,6.38,0,0,0,61.3,64.65Zm1.1,6.9a2.74,2.74,0,0,1-1.3,1.7,2.58,2.58,0,0,1-2.1.3,2.74,2.74,0,0,1-1.7-1.3,2.58,2.58,0,0,1-.3-2.1,3,3,0,0,1,1.2-1.7h0a2.3,2.3,0,0,1,1.4-.4,2,2,0,0,1,.7.1,2.74,2.74,0,0,1,1.7,1.3A2.34,2.34,0,0,1,62.4,71.55Z" transform="translate(-2 -1.15)" style="fill:#f1f0ef "/></svg>'+
            '</div>'+
            '<strong>Browse and buy from our TV & movie stores.</strong>'+
            '<p>Play items from <strong>&lsquo;My Stuff&rsquo;</strong> on your mobile device or set top box.<br>'+
            '<sub>Excludes items listed with &lsquo;mobile playback unavailable&rsquo;.</sub>'+
            '</p>'+
            '</div>'+
            '<div ng-switch-when="2" class="slide">'+
            '<h2>Manage settings</h2>'+
            '<div class="icon-container">'+
            '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 120 120"><defs><linearGradient id="linear-gradient" x1="153.91" y1="99.76" x2="107.32" y2="63.15" gradientTransform="matrix(1, 0, 0, -1, -47, 122.9)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2997d3 " stop-opacity="0"/><stop offset="1" stop-color="#048acb "/></linearGradient></defs><title>test</title><circle cx="60" cy="60" r="60" style="fill:#2997d3 "/><circle cx="60" cy="60" r="60" style="fill:url(#linear-gradient)"/><path d="M107,72.2a10.8,10.8,0,1,1,10.8-10.8A10.82,10.82,0,0,1,107,72.2Zm0-18.3a7.5,7.5,0,1,0,7.5,7.5A7.55,7.55,0,0,0,107,53.9Z" transform="translate(-47 -1.4)" style="fill:#fffcfc "/><path d="M107,87.55a12.25,12.25,0,0,1-1.8-.1,4.14,4.14,0,0,1-3.6-3.5l-.5-3.2s-.1-.2-.2-.2l-3.1-1.3c-.2-.1-.4-.1-.4,0l-2.6,1.9c-1.7,1.3-4.5.3-5.5-.5l-.5-.5-.3-.3h0s-1.1-1.2-1.5-1.7a3.77,3.77,0,0,1,.2-4.6l2-2.6v-.3l-1.3-3.1q-.15-.3-.3-.3l-3.2-.4a4.24,4.24,0,0,1-3.5-3.6,16.25,16.25,0,0,1,0-3.6,4.14,4.14,0,0,1,3.5-3.6l3.2-.5s.2-.1.2-.2l1.3-3.1c.1-.2.1-.4,0-.4l-1.9-2.6a4.06,4.06,0,0,1,.2-5l2.2-2.3a4.08,4.08,0,0,1,5.1-.3l2.6,2h.3l3.1-1.3q.3-.15.3-.3l.5-3.2a4.24,4.24,0,0,1,3.6-3.5,16.25,16.25,0,0,1,3.6,0,4.14,4.14,0,0,1,3.6,3.5l.5,3.2s.1.2.2.2l3.1,1.3c.2.1.4.1.4,0l2.6-1.9a4.06,4.06,0,0,1,5,.2l2.3,2.3a4.08,4.08,0,0,1,.3,5.1l-2,2.6v.3l1.3,3.1q.15.3.3.3l3.2.5a4.24,4.24,0,0,1,3.5,3.6h0a16.25,16.25,0,0,1,0,3.6,4.24,4.24,0,0,1-3.5,3.6l-3.2.5s-.2.1-.2.2l-1.3,3.1c-.1.2-.1.4,0,.4l1.9,2.6a4.05,4.05,0,0,1-.2,5l-2.2,2.3a4.08,4.08,0,0,1-5.1.3l-2.6-2h-.2l-3.1,1.3q-.3.15-.3.3l-.5,3.2a4.14,4.14,0,0,1-3.6,3.5A9.79,9.79,0,0,0,107,87.55Zm1.1-4.2Zm-2.2,0Zm0-.2h2.2l.4-3a4.7,4.7,0,0,1,3.1-3.7l2.8-1.2a4.54,4.54,0,0,1,4.6.5l2.4,1.8,1.6-1.6-1.8-2.4a4.61,4.61,0,0,1-.4-4.8l1.1-2.8a4.53,4.53,0,0,1,3.6-2.9l3-.4v-2.2l-3-.4a4.7,4.7,0,0,1-3.7-3.1l-1.1-2.8a4.54,4.54,0,0,1,.5-4.6l1.8-2.4-1.6-1.6-2.4,1.8a4.61,4.61,0,0,1-4.8.4l-2.8-1.1a4.53,4.53,0,0,1-2.9-3.6l-.4-3H106l-.4,3a4.7,4.7,0,0,1-3.1,3.7l-2.8,1.2a4.54,4.54,0,0,1-4.6-.5l-2.4-1.8-1.6,1.6,1.8,2.4a4.61,4.61,0,0,1,.4,4.8l-1.1,2.8a4.53,4.53,0,0,1-3.6,2.9l-3,.4v2.2l3,.4a4.88,4.88,0,0,1,3.7,3.1l1.1,2.8a4.54,4.54,0,0,1-.5,4.6L91.05,76a5.93,5.93,0,0,0,.8.8l.6.5c.1,0,.3.1.4.1l2.3-1.7a4.63,4.63,0,0,1,4.8-.4l2.7,1.1a4.53,4.53,0,0,1,2.9,3.6Zm-13.5-5.7Zm-1.9-1.9Zm1.8-30.2Zm13.6-5.6Zm2.2,0Z" transform="translate(-47 -1.4)" style="fill:#fffcfc "/></svg>'+
            '</div>'+
            '<strong>Manage your account from the &lsquo;Manage&rsquo; area.</strong>'+
            '<p>You can review your billing information, transaction history and make account changes like changing your PIN.</p>'+
            '</div>'+
            '</div>'+
            '<div class="tourControls">'+
            '<div>'+
            '<button ng-click="next()" class="btn btn-default">{{buttonText}}</button>'+
            '</div>'+
            '</div>',
        controller: ['$scope','$timeout','$uibModal','$uibModalInstance','tourModalService','appLinkService', function ($scope,$timeout, $uibModal,$uibModalInstance, tourModalService,appLinkService) {
          var slideCount = 2;
          $scope.page = 1;      
          $scope.buttonText = 'Next';
          $scope.finishTour = function () {
            tourModalService.finishTour();
            $uibModalInstance.close();
          }
          $scope.downloadOrLaunchDeviceApp = function(){
            appLinkService.downloadApp();
          }

          $scope.next = function () {
            $scope.page ++;
            switch (true){
              case $scope.page < slideCount:
                $scope.buttonText = 'Next'
                break;
              case $scope.page == slideCount:
                $scope.buttonText = 'Finish';
                break;
              case $scope.page > slideCount:
                $scope.finishTour();
            }

          }
        }],
          windowClass: 'invisible-modal'
        });
      }

      function isTourTaken(){
        return $cookies.get('retail-tour-taken') == 'true';

      }

      function finishTour(){
        $cookies.put('retail-tour-taken',true);
      }
      return {
        beginTour: beginTour,
        finishTour: finishTour,
        isTourTaken:isTourTaken
      }
    });
})();

(function() {
    'use strict';
    angular.module('fetch-web-angular')
        .directive('retailSideMenu',
          function() {
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="retail-side-menu" ng-show="!menuHidden">' +
                          '  <ul>' +
                          '    <li ng-repeat="parentItem in navigationStructure">' +
                          '      <h4 ng-class="{collapsable: collapsableGroupHeader==\'true\',noncollapsable: collapsableGroupHeader!=\'true\', collapsed: !open(parentItem)}" class="retail-side-menu-header" id="title-{{ parentItem.groupId }}-{{bootstrapId}}" role="button" aria-expanded="false" ng-click="toggleGroup(parentItem)" aria-controls="{{ parentItem.groupId + bootstrapId }}">' +
                          '        <div class="left-header-section">' +
                          '          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" class="plus-minus-icon" xml:space="preserve">' +
                          '            <!-- Circle-->' +
                          '            <path class="icon icon-circle" d="M10,20C4.5,20,0,15.5,0,10S4.5,0,10,0s10,4.5,10,10S15.5,20,10,20z M10,1c-5,0-9,4-9,9s4.1,9,9,9s9-4.1,9-9S15,1,10,1z"/>' +
                          '            <!-- plus-->' +
                          '            <path class="icon icon-plus" d="M15,9h-4V5c0-0.6-0.4-1-1-1S9,4.4,9,5v4H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h4v4c0,0.6,0.4,1,1,1s1-0.4,1-1v-4h4c0.6,0,1-0.4,1-1S15.6,9,15,9z"/>' +
                          '            <!-- minus -->' +
                          '            <path class="icon icon-minus" d="M14.8,9.1H5.2c-0.5,0-1,0-1,0.5s0.4,0.5,1,0.5h9.5c0.5,0,1,0,1-0.5S15.3,9.1,14.8,9.1z"/>' +
                          '          </svg>' +
                          '        </div>' +
                          '        <div class="right-header-section">' +
                          '          {{ parentItem.group }}' +
                          '        </div>' +
                          '      </h4>' +
                          '      <ul id="{{ parentItem.groupId  + bootstrapId}}" aria-labelledby="title-{{ parentItem.groupId + bootstrapId}}" ng-class="{\'in\': open(parentItem), \'collapse\': !open(parentItem) }">' +
                          '        <li ng-repeat="item in parentItem.items" ng-click="goTo(item, $event)" ng-class="{\'selected\': selected(item), \'disabled\': menuDisabled && !item.alwaysAvailable, \'hidden\': menuHidden}">' +
                          '          <div class="body-section-text">{{ item.name }}</div>' +
                          '          <div class="body-section-right-arrow pull-right">' +
                          '            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 32 24" enable-background="new 0 0 26 26" width="32px" height="24px">' +
                          '              <path d="M16.7,22.7l9-9c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7l-9-9C16.5,3.1,16.3,3,16,3s-0.5,0.1-0.7,0.3l-1.4,1.4  c-0.4,0.4-0.4,1,0,1.4l4,4c0.3,0.3,0.1,0.9-0.4,0.9H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h16.6c0.4,0,0.7,0.5,0.4,0.9l-4,4  c-0.4,0.4-0.4,1,0,1.4l1.4,1.4c0.2,0.2,0.4,0.3,0.7,0.3C16.3,23,16.5,22.9,16.7,22.7z" fill="#FFFFFF"/>' +
                          '            </svg>' +
                          '          </div>' +
                          '        </li>' +
                          '      </ul>' +
                          '    </li>' +
                          '  </ul>' +
                          '</div>'
                ,
                scope:{
                  menuHidden:'=',
                  menuDisabled: '=',
                  excludeGroup:'@',
                  onlyGroup:'@',
                  collapsableGroupHeader:'@',
                  bootstrapId:'@',
                  isItemSelected:'&'
                },
                compile: function(element, attrs){
                  if ( angular.isUndefined(attrs.menuHidden) ) { attrs.menuHidden = 'menuHidden'; }
                  if ( angular.isUndefined(attrs.menuDisabled) ) { attrs.menuDisabled = 'menuDisabled'; }

                },
              controller: [
                '$scope',
                'retailSideMenuService',
                'messageBus',
                function(
                  $scope,
                  retailSideMenuService,
                  messageBus
                ) {

                  switch (true){
                    case $scope.onlyGroup:
                      $scope.navigationStructure = _.filter(retailSideMenuService.navigationItems,function(group){ return group.groupId == $scope.onlyGroup;});
                      break;
                    case $scope.excludeGroup:
                      $scope.navigationStructure = _.filter(retailSideMenuService.navigationItems, function (group) {
                        return group.groupId != $scope.excludeGroup;
                      });
                      break;
                    default:
                      $scope.navigationStructure = retailSideMenuService.navigationItems;
                  }

                  $scope.collapsableGroupHeader = $scope.collapsableGroupHeader==='false'? 'false' : 'true';

                  $scope.goTo = function(item, event) {
                    if (!($scope.menuDisabled || $scope.menuHidden) || item.alwaysAvailable) {
                      messageBus.emitMessage('retail-side-menu-clicked',item);
                    }
                  };

                  $scope.selected = function(menuItem) {
                      return $scope.isItemSelected({menuItem:menuItem});
                  };

                  var groupOpen = {};
                  $scope.toggleGroup = function (group) {
                    groupOpen[group.group] = !$scope.open(group);
                  };

                  $scope.open = function(parent) {
                    if (angular.isDefined(groupOpen[parent.group])) {
                      return groupOpen[parent.group] === true;
                    }
                    return (parent.items || []).some(function (item) { return $scope.isItemSelected({menuItem:item}); });
                  };
                }]
            };
        });
})();

'use strict';
(function() {
  angular.module('fetch-web-angular')
    .factory('retailSideMenuService', function() {
      return {
        navigationItems: [{
            'group': 'Account Settings',
            'groupId': 'myAccount',
            'iconClass':'svg-settings-account',
            'items': [{
              'name': 'Username & Password',
              'view': 'password',
              isCurrentView: /^\/password/
            }, {
              'name': 'Account Details',
              'view': 'accountdetails',
              isCurrentView: /^\/accountdetails/
            }, {
              'name': 'Parental PIN',
              'view': 'parentalpin',
              isCurrentView: /^\/parentalpin/
            }, {
              'name': 'Add & Remove Fetch Box',
              'view': 'addandremovebox',
              isCurrentView: /^\/addandremovebox/
            }]
          }, {
            'group': 'Billing & Payments',
            'groupId': 'billingPayments',
            'iconClass':'svg-settings-billing',
            'items': [{
              'name': 'Update Billing Details',
              'view': 'billingdetails',
              isCurrentView: /^\/billingdetails/
            },{
              'name': 'Movie Credits',
              'view': 'credits',
              isCurrentView: /^\/credits/,
              'action':{name:'show-credits'}

            },
              {
              'name': 'Transaction History',
              'view': 'transactionhistory',
              isCurrentView: /^\/transactionhistory/
            }, {
              'name': 'Tax Invoices',
              'view': 'taxinvoices',
              isCurrentView: /^\/taxinvoices/
            }]
          },
          {
            'group': 'Packages',
            'groupId': 'packages',
            'iconClass':'svg-settings-packages',
            'items': [{
              'name': 'My Packages',
              'action':{name:'navigate-store-account-section', sectionUrl:'/settings/package-management',featureName:'My Packages'},
            },
            {
              'name': 'Cancel Service',
              'view': 'cancelservice',
              isCurrentView: /^\/cancelservice/
            }]
          },
          {
            'group': 'Support',
            'groupId': 'support',
            'iconClass':'svg-settings-support',
            'items': [
            {
              'name': 'Installation',
              'view': 'support/Installation',
              isCurrentView: /^\/support\/Installation/,
              'alwaysAvailable': true,
              'iconClass':'icon-help-installation',
              'description':'Quick start guide'
            }, {
              'name': 'How-To Guides',
              'view': 'support/How-To Guides',
              isCurrentView: /^\/support\/How-To Guides/,
              'alwaysAvailable': true,
              'iconClass':'icon-help-howto',
              'description':'Our guides'
            }, {
              'name': 'Hardware Replacement',
              'view': 'hardware',
              isCurrentView: /^\/hardware/
            }, {
              'name': 'Accessories',
              'view': 'accessories',
              isCurrentView: /^\/accessories/
            }, {
              'name': 'FAQs',
              'view': 'support/FAQs',
              isCurrentView: /^\/support\/FAQs/,
              'alwaysAvailable': true,
              'iconClass':'icon-help-faqs',
              'description':'Frequently asked questions'
            }, {
              'name': 'Billing Queries',
              'view': 'support/Billing Queries',
              isCurrentView: /^\/support\/Billing Queries/,
              'alwaysAvailable': true,
              'description':"FAQ's",
              'iconClass':'icon-help-billing',
            }, {
              'name': 'Technical Help',
              'view': 'support/Technical Help',
              isCurrentView: /^\/support\/Technical Help/,
              'alwaysAvailable': true,
              'iconClass':'icon-help-tech',
              'description':'Troubleshooting guide'
            }]
          },
        ]
      };
    });
})();

